(function () {
  var controllersBySection = {};
  var globalVariantEventsBound = false;
  var NativePromise = typeof Promise === 'function' ? Promise : null;

  function handleGlobalVariantEvent(event) {
    if (!controllersBySection) {
      return;
    }
    var sectionIds = Object.keys(controllersBySection);
    for (var i = 0; i < sectionIds.length; i += 1) {
      var controller = controllersBySection[sectionIds[i]];
      if (controller && typeof controller.refreshFromInputs === 'function') {
        controller.refreshFromInputs(event);
      }
    }
  }

  function bindGlobalVariantEvents() {
    if (globalVariantEventsBound || typeof document === 'undefined') {
      return;
    }
    var events = ['variant:change', 'variant:changed', 'product:variant-change'];
    for (var i = 0; i < events.length; i += 1) {
      document.addEventListener(events[i], handleGlobalVariantEvent);
    }
    globalVariantEventsBound = true;
  }

  bindGlobalVariantEvents();

  function sanitizeVariantId(value) {
    if (value === null || value === undefined) {
      return '';
    }
    return String(value).trim();
  }

  function resolveProductUrl(form) {
    if (!form) {
      return window.location.pathname;
    }
    var url = form.getAttribute('data-product-url');
    if (url && url.trim() !== '') {
      return url;
    }
    var handle = form.getAttribute('data-product-handle');
    if (handle && handle.trim() !== '') {
      if (handle.charAt(0) === '/') {
        return handle;
      }
      return '/products/' + handle.trim();
    }
    return window.location.pathname;
  }

  function matchesVariantId(ids, variantId, numericVariantId) {
    if (!ids || !ids.length) {
      return false;
    }
    for (var i = 0; i < ids.length; i += 1) {
      var id = ids[i];
      if (!id) {
        continue;
      }
      if (variantId && id === variantId) {
        return true;
      }
      if (numericVariantId) {
        var numericId = id.replace(/\D/g, '');
        if (numericId && numericId === numericVariantId) {
          return true;
        }
      }
    }
    return false;
  }

  function getVariantIds(node) {
    if (!node) {
      return [];
    }
    return (node.getAttribute('data-variant-ids') || '')
      .split(',')
      .map(function (entry) {
        return entry ? entry.trim() : '';
      })
      .filter(function (entry) {
        return entry !== '';
      });
  }

  function partitionNodes(items, variantId, numericVariantId) {
    var variantItems = [];
    var genericItems = [];
    var otherItems = [];

    for (var i = 0; i < items.length; i += 1) {
      var item = items[i];
      if (!item) {
        continue;
      }
      var ids = getVariantIds(item);
      if (!ids.length || !variantId) {
        genericItems.push(item);
      } else if (matchesVariantId(ids, variantId, numericVariantId)) {
        variantItems.push(item);
      } else {
        otherItems.push(item);
      }
    }

    return {
      variant: variantItems,
      generic: genericItems,
      other: otherItems
    };
  }

  function moveNodes(container, nodes) {
    if (!container || !nodes || !nodes.length) {
      return;
    }
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node && node.parentElement === container) {
        container.appendChild(node);
      }
    }
  }

  function revealNode(node) {
    if (!node) {
      return;
    }
    node.classList.remove('d-none');
    node.removeAttribute('hidden');
    if (node.style && typeof node.style.removeProperty === 'function') {
      node.style.removeProperty('display');
    }
  }

  function concealNode(node) {
    if (!node) {
      return;
    }
    node.classList.add('d-none');
    node.setAttribute('hidden', 'true');
    if (node.style) {
      node.style.display = 'none';
    }
  }

  function resetCarouselScroll(container) {
    if (!container) {
      return;
    }
    if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(min-width: 769px)').matches) {
      container.scrollLeft = 0;
      try {
        if (typeof Event === 'function') {
          container.dispatchEvent(new Event('scroll'));
        } else if (typeof document !== 'undefined' && document.createEvent) {
          var evt = document.createEvent('Event');
          evt.initEvent('scroll', true, true);
          container.dispatchEvent(evt);
        }
      } catch (error) {
        // ignore dispatch errors
      }
    }
  }

  function getPrimarySlideImages(wrapper) {
    if (!wrapper) {
      return [];
    }
    var selectors = ['.js-product-slideshow-item.d-block', '.js-product-slideshow-item:not([hidden]):not(.d-none)'];
    var primarySlide = null;
    for (var i = 0; i < selectors.length; i += 1) {
      primarySlide = wrapper.querySelector(selectors[i]);
      if (primarySlide) {
        break;
      }
    }
    if (!primarySlide) {
      primarySlide = wrapper.querySelector('.js-product-slideshow-item');
    }
    if (!primarySlide) {
      return [];
    }
    return Array.prototype.slice.call(primarySlide.querySelectorAll('img'));
  }

  function preloadImages(images) {
    if (!NativePromise || typeof window === 'undefined' || typeof window.Image !== 'function') {
      return null;
    }
    if (!images || !images.length) {
      return NativePromise.resolve();
    }
    var tasks = [];
    for (var i = 0; i < images.length; i += 1) {
      (function (image) {
        if (!image) {
          return;
        }
        var src = image.getAttribute('src') || image.getAttribute('data-src') || '';
        var srcset = image.getAttribute('srcset') || image.getAttribute('data-srcset') || '';
        var sizes = image.getAttribute('sizes') || '';
        if (!src && !srcset) {
          return;
        }
        var task = new NativePromise(function (resolve) {
          var loader = new window.Image();
          var resolved = false;
          var cleanup = function () {
            if (resolved) {
              return;
            }
            resolved = true;
            loader.removeEventListener('load', cleanup);
            loader.removeEventListener('error', cleanup);
            resolve();
          };
          loader.addEventListener('load', cleanup);
          loader.addEventListener('error', cleanup);
          if (sizes) {
            loader.sizes = sizes;
          }
          if (srcset) {
            loader.srcset = srcset;
          }
          if (src) {
            loader.src = src;
          } else {
            var candidate = srcset.split(',').pop();
            if (candidate) {
              var parts = candidate.trim().split(/\s+/);
              if (parts.length) {
                loader.src = parts[0];
              }
            }
          }
          if (loader.complete && loader.naturalWidth > 0) {
            cleanup();
          }
        });
        tasks.push(task);
      })(images[i]);
    }
    if (!tasks.length) {
      return NativePromise.resolve();
    }
    return NativePromise.all(tasks);
  }

  function filterGallery(wrapper, variantId) {
    if (!wrapper) {
      return;
    }

    var variantIdString = sanitizeVariantId(variantId);
    var numericVariantId = variantIdString.replace(/\D/g, '');

    var slideContainers = wrapper.querySelectorAll('.js-product-slideshow');
    for (var i = 0; i < slideContainers.length; i += 1) {
      var slideContainer = slideContainers[i];
      if (!slideContainer) {
        continue;
      }
      var slideItems = Array.prototype.slice.call(slideContainer.querySelectorAll('.js-product-slideshow-item'));
      if (!slideItems.length) {
        continue;
      }

      var slideGroups = partitionNodes(slideItems, variantIdString, numericVariantId);
      var orderedSlides = slideGroups.variant.concat(slideGroups.generic, slideGroups.other);
      moveNodes(slideContainer, orderedSlides);

      var preferredSlides = slideGroups.variant.length
        ? slideGroups.variant
        : slideGroups.generic;
      var slidesToShow = preferredSlides.filter(function (item) {
        return item && typeof item.nodeType === 'number';
      });
      if (!slidesToShow.length && orderedSlides.length) {
        slidesToShow = [orderedSlides[0]];
      }

      var firstSlide = slidesToShow[0] || orderedSlides[0] || null;
      var slidesToHide = orderedSlides.filter(function (item) {
        return slidesToShow.indexOf(item) === -1;
      });

      for (var s = 0; s < slidesToShow.length; s += 1) {
        var slideToShow = slidesToShow[s];
        if (!slideToShow) {
          continue;
        }
        revealNode(slideToShow);
        if (slideToShow !== firstSlide) {
          slideToShow.classList.remove('d-block');
          if (slideToShow.style && typeof slideToShow.style.removeProperty === 'function') {
            slideToShow.style.removeProperty('display');
          }
        }
      }

      if (firstSlide) {
        revealNode(firstSlide);
        if (!firstSlide.classList.contains('d-block')) {
          firstSlide.classList.add('d-block');
        }
      }

      for (var h = 0; h < slidesToHide.length; h += 1) {
        var slideToHide = slidesToHide[h];
        if (!slideToHide) {
          continue;
        }
        slideToHide.classList.remove('d-block');
        concealNode(slideToHide);
      }

      resetCarouselScroll(slideContainer);
    }

    var thumbContainers = [];
    var thumbs = wrapper.querySelectorAll('.js-product-slideshow-thumb');
    for (var j = 0; j < thumbs.length; j += 1) {
      var thumb = thumbs[j];
      if (!thumb) {
        continue;
      }
      var thumbContainer = thumb.closest('.js-carousel-items');
      if (!thumbContainer) {
        continue;
      }
      if (thumbContainers.indexOf(thumbContainer) === -1) {
        thumbContainers.push(thumbContainer);
      }
    }

    for (var n = 0; n < thumbContainers.length; n += 1) {
      var thumbContainerNode = thumbContainers[n];
      if (!thumbContainerNode) {
        continue;
      }
      var thumbItems = Array.prototype.slice.call(thumbContainerNode.querySelectorAll('.js-product-slideshow-thumb'));
      if (!thumbItems.length) {
        continue;
      }

      var thumbGroups = partitionNodes(thumbItems, variantIdString, numericVariantId);
      var orderedThumbs = thumbGroups.variant.concat(thumbGroups.generic, thumbGroups.other);
      moveNodes(thumbContainerNode, orderedThumbs);

      var preferredThumbs = thumbGroups.variant.length
        ? thumbGroups.variant
        : thumbGroups.generic;
      var thumbsToShow = preferredThumbs.filter(function (item) {
        return item && typeof item.nodeType === 'number';
      });
      if (!thumbsToShow.length && orderedThumbs.length) {
        thumbsToShow = [orderedThumbs[0]];
      }

      for (var t = 0; t < orderedThumbs.length; t += 1) {
        var thumbItem = orderedThumbs[t];
        if (thumbsToShow.indexOf(thumbItem) !== -1) {
          revealNode(thumbItem);
        } else {
          concealNode(thumbItem);
        }
        thumbItem.classList.remove('is-active-item');
      }

      if (thumbsToShow[0]) {
        revealNode(thumbsToShow[0]);
        thumbsToShow[0].classList.add('is-active-item');
      }
    }
  }

  function syncWrapperAttributes(target, source) {
    if (!target || !source) {
      return;
    }

    var removable = [];
    for (var i = 0; i < target.attributes.length; i += 1) {
      var attr = target.attributes[i];
      if (!source.hasAttribute(attr.name)) {
        removable.push(attr.name);
      }
    }
    for (var j = 0; j < removable.length; j += 1) {
      target.removeAttribute(removable[j]);
    }

    for (var k = 0; k < source.attributes.length; k += 1) {
      var sourceAttr = source.attributes[k];
      target.setAttribute(sourceAttr.name, sourceAttr.value);
    }
  }

  function createController(sectionId, initialForm) {
    if (!sectionId || !initialForm) {
      return null;
    }
    var wrapperSelector = '.js-product-media-wrapper[data-section="' + sectionId + '"]';
    var wrapper = document.querySelector(wrapperSelector);
    if (!wrapper) {
      return null;
    }

    var productUrl = resolveProductUrl(initialForm);
    var cache = {};
    var currentVariant = sanitizeVariantId((initialForm.querySelector('input[name="id"]') || {}).value);
    var trackedVariantInputs = [];
    var eventRefreshScheduled = false;

    function buildRequestUrl(variantId) {
      var base = productUrl || window.location.pathname;
      var resolved;
      try {
        resolved = new URL(base, window.location.origin);
      } catch (error) {
        resolved = new URL(window.location.href);
        resolved.pathname = base;
        resolved.search = '';
      }
      resolved.searchParams.set('variant', variantId);
      resolved.searchParams.set('section_id', sectionId);
      return resolved.toString();
    }

    function applyMarkup(html, variantId) {
      if (!html) {
        return NativePromise ? NativePromise.resolve() : null;
      }
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var freshWrapper = doc.querySelector(wrapperSelector);
      if (!freshWrapper) {
        return NativePromise ? NativePromise.resolve() : null;
      }
      filterGallery(freshWrapper, variantId);
      var primaryImages = getPrimarySlideImages(freshWrapper);
      for (var i = 0; i < primaryImages.length; i += 1) {
        var primaryImage = primaryImages[i];
        if (primaryImage) {
          primaryImage.setAttribute('loading', 'eager');
          primaryImage.setAttribute('fetchpriority', 'high');
        }
      }
      var finalize = function () {
        syncWrapperAttributes(wrapper, freshWrapper);
        wrapper.innerHTML = freshWrapper.innerHTML;
        var sectionWrapper = document.getElementById('shopify-section-' + sectionId);
        if (!sectionWrapper) {
          sectionWrapper = wrapper.closest('[data-section]');
        }
        if (typeof window.initVariantSwatchGallery === 'function') {
          window.initVariantSwatchGallery(sectionWrapper || wrapper);
        }
        currentVariant = variantId;
        wrapper.setAttribute('data-variant-media-current', variantId);
        document.dispatchEvent(
          new CustomEvent('variant:media-updated', {
            detail: {
              sectionId: sectionId,
              variantId: variantId
            }
          })
        );
      };
      var preloadPromise = preloadImages(primaryImages);
      if (!preloadPromise || typeof preloadPromise.then !== 'function') {
        finalize();
        return NativePromise ? NativePromise.resolve() : null;
      }
      return preloadPromise
        .catch(function () {
          // Ignore preload errors and continue rendering
        })
        .then(function () {
          finalize();
        });
    }

    function loadVariant(variantId) {
      var targetVariant = sanitizeVariantId(variantId);
      if (!targetVariant) {
        return;
      }
      if (targetVariant === currentVariant && wrapper.getAttribute('data-variant-media-current') === targetVariant) {
        return;
      }
      wrapper.setAttribute('data-variant-media-loading', 'true');
      wrapper.setAttribute('aria-busy', 'true');
      var updatePromise;
      if (cache[targetVariant]) {
        updatePromise = NativePromise ? NativePromise.resolve(cache[targetVariant]) : cache[targetVariant];
      } else {
        var requestUrl = buildRequestUrl(targetVariant);
        updatePromise = fetch(requestUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Failed to fetch variant media');
            }
            return response.text();
          })
          .then(function (html) {
            cache[targetVariant] = html;
            return html;
          });
      }
      if (updatePromise && typeof updatePromise.then === 'function') {
        updatePromise
          .then(function (html) {
            return applyMarkup(html, targetVariant);
          })
          .catch(function (error) {
            console.error('Variant media update error for section ' + sectionId, error);
          })
          .then(function () {
            if (wrapper && wrapper.removeAttribute) {
              wrapper.removeAttribute('data-variant-media-loading');
              wrapper.removeAttribute('aria-busy');
            }
          });
      } else {
        try {
          applyMarkup(updatePromise, targetVariant);
        } catch (error) {
          console.error('Variant media update error for section ' + sectionId, error);
        }
        if (wrapper && wrapper.removeAttribute) {
          wrapper.removeAttribute('data-variant-media-loading');
          wrapper.removeAttribute('aria-busy');
        }
      }
    }

    function getVariantFromTrackedInputs() {
      for (var index = 0; index < trackedVariantInputs.length; index += 1) {
        var inputNode = trackedVariantInputs[index];
        if (inputNode && inputNode.value) {
          return inputNode.value;
        }
      }
      return '';
    }

    function scheduleRefreshFromInputs() {
      if (eventRefreshScheduled) {
        return;
      }
      eventRefreshScheduled = true;
      var scheduleCallback = function () {
        eventRefreshScheduled = false;
        var candidate = sanitizeVariantId(getVariantFromTrackedInputs());
        if (candidate) {
          loadVariant(candidate);
        }
      };
      if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(scheduleCallback);
      } else if (typeof window !== 'undefined' && typeof window.setTimeout === 'function') {
        window.setTimeout(scheduleCallback, 0);
      } else {
        scheduleCallback();
      }
    }

    function attachForm(form) {
      if (!form || form.getAttribute('data-variant-media-listener') === 'true') {
        return;
      }
      var variantInput = form.querySelector('input[name="id"]');
      if (!variantInput) {
        return;
      }
      var alreadyTracked = false;
      for (var idx = 0; idx < trackedVariantInputs.length; idx += 1) {
        if (trackedVariantInputs[idx] === variantInput) {
          alreadyTracked = true;
          break;
        }
      }
      if (!alreadyTracked) {
        trackedVariantInputs.push(variantInput);
      }
      form.setAttribute('data-variant-media-listener', 'true');

      var schedule = false;
      function triggerUpdate() {
        if (schedule) {
          return;
        }
        schedule = true;
        window.requestAnimationFrame(function () {
          schedule = false;
          loadVariant(variantInput.value);
        });
      }

      form.addEventListener('change', function (event) {
        if (!event || !event.target) {
          return;
        }
        var name = event.target.name || '';
        if (name === 'id' || name.indexOf('options[') === 0) {
          triggerUpdate();
        }
      });

      variantInput.addEventListener('change', triggerUpdate);
    }

    attachForm(initialForm);
    filterGallery(wrapper, currentVariant);
    wrapper.setAttribute('data-variant-media-current', currentVariant);

    return {
      attachForm: attachForm,
      refreshFromInputs: scheduleRefreshFromInputs
    };
  }

  function init(context) {
    var scope = context && context.querySelectorAll ? context : document;
    var forms = scope.querySelectorAll('sht-prd-frm[data-section]');
    for (var i = 0; i < forms.length; i += 1) {
      var form = forms[i];
      if (!form) {
        continue;
      }
      var sectionId = form.getAttribute('data-section');
      if (!sectionId) {
        continue;
      }
      var controller = controllersBySection[sectionId];
      if (!controller) {
        controller = createController(sectionId, form);
        if (controller) {
          controllersBySection[sectionId] = controller;
        }
      } else if (controller && typeof controller.attachForm === 'function') {
        controller.attachForm(form);
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var target = event && event.target;
    if (target && target.id) {
      var sectionId = target.id.replace('shopify-section-', '');
      if (sectionId && controllersBySection[sectionId]) {
        delete controllersBySection[sectionId];
      }
    }
    init(target || document);
  });
})();
